<template>
  <nuxt-link
    class="c-nav-card-featured"
    :to="navItem.linkUrl"
  >
    <template v-if="navItem">
      <div class="l-flex l-flex--align-evenly l-flex__nowrap">
        <div class="c-nav-card-featured__left l-flex__item">
          <div class="c-nav-card-featured__header">
            <header class="t-heading-8">
              {{ navItem.title }}
            </header>
          </div>
          <header
            v-if="navItem.linkText && navItem.linkText.length > 0"
            class="c-nav-card-featured__subheader t-heading-8"
          >
            {{ navItem.linkText }}
          </header>
        </div>
        <div class="l-flex__item">
          <img
            class="c-nav-card-featured__image"
            :src="navItem.image.src"
            :alt="navItem.image.alt"
          >
        </div>
      </div>
    </template>
  </nuxt-link>
</template>

<script>
export default {
  name: "NavCardFeatured",
  props:{
    navItem: {
      type: Object,
      default: null
    }
  },
  data(){
    return {

    }
  },
  mounted(){

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
  .c-nav-card-featured{
    padding: $filter-padding;
    cursor: pointer;
    display: block;
    @include themify($themes){
      background-color: themed("background", "xx-light");
    }
    &__image{
      height: rem(80px);
    }

    &__header{
      text-align: center;
      margin-bottom: rem(12px);
      & header{
        @include themify($themes){
          background-color: themed("accent", "base");
          color: themed("foreground", "white-text");
        }
        display: inline-block;
        padding: rem(5px) rem(7px);
      }
    }

    &__left{
      margin-right: rem(40px);
    }

    &__subheader{
      @include themify($themes){
        color: themed("primary", "base");
      }
      text-align: center;
      text-decoration: underline;
    }

    &:hover{
      .c-nav-card-featured__header header{
        @include themify($themes){
          background-color: themed("foreground", "hover");
        }
      }
    }
  }
</style>
